<template>
  <van-config-provider :theme-vars="themeVars">
  <div class="van-hairline--surround">
       <van-cell-group inset border="false">
         <h3 style="padding-top: 1em;">关于我们</h3>
         <p class="textIndentation">北京云腾优仕是中科软(股票:603927)生态企业，是国内心血管一级预防创新推动者。</p>
         <p class="textIndentation">中科知心,又称早知心，是由中国科学院下属中科软发起，联合友谊医院、首都医科大学附属安贞医院等相关领域专家共同创建，推动中国心血管病中高危人群，更早期的预防管理。</p>
         <p class="textIndentation">{{ userInfo.hospitalName }}，是早期参与此项目医疗机构，我院目标通过体检端的筛查，并结合院内深厚的医疗资源，帮助心血管病高风险人群，早发现、早干预，既要实现个人的健康目标，
            又要最大力度帮助患者省钱。未病先医，未病先治。
          </p>
       </van-cell-group>
       <van-cell-group title="我们为您提供了几分钟视频，以便更好了解这个项目" inset>
          <video id="player-container-id"  width="360" height="230" preload="auto" playsinline webkit-playsinline></video>
        </van-cell-group>
        <br/>
       <p class="match">
          <van-notice-bar color="#EA6853" wrapable :scrollable="false">
            <strong>如果您有任何问题，可以在公众号底部留言，我们会及时回复。</strong>
         </van-notice-bar>
          </p>
   </div>
 </van-config-provider>
 <van-overlay :show="showOverlay" @click="showOverlay = false">
        <div class="wrapper" @click.stop>
            <div class="block">
                <van-cell-group inset>
                    <van-notice-bar wrapable :scrollable="false" text="异常提醒" left-icon="info-o" />
                    <p class="textIndentation">
                        <van-notice-bar wrapable :scrollable="false" color="#1989fa" background="#ffffff">{{ bingingNotice
                        }}</van-notice-bar>
                    </p>
                    <van-button v-if="goToUserInfo" type="warning" block plain hairline to="bindingHosp">
                        开始绑定
                    </van-button>
                </van-cell-group>
            </div>
        </div>
    </van-overlay>
</template>
<script>
import { ref,toRefs,reactive, onMounted } from 'vue';
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import { postUserLog } from '../../api/userlog'
import { useRouter } from 'vue-router';
import { getCheckBinding } from '../../api/permission'
import { getUserInfo} from '../../api/userinfo'
export default {
 setup() {

   const themeVars = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const kpian = reactive({
     cellGroupBackground: '#AAAAAA',
   });
   const kpianawait = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const themeVars2 = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   let player = reactive(null)
   const router = useRouter(); 
   const goToUserInfo = ref(false);
   const bingingNotice = ref('');
   const showOverlay = ref(false);
   const state = reactive({
            userInfo: {
                hospitalName: '',
                area: '',
                realName: '',
                phone: '',
                age: '',
                gender: ''
            }
        });
   const ulog = reactive({
      UserLog: {
        path: '',
      }
    })
   onMounted(() => {
     player = TCPlayer('player-container-id',
     {
          fileID: '1253642699157561839', // 请传入需要播放的视频 fileID（必须）
          appID: '1318167223', // 请传入点播账号的 appID（必须）
          psign: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6MTMxODE2NzIyMywiZmlsZUlkIjoiMTI1MzY0MjY5OTE1NzU2MTgzOSIsImN1cnJlbnRUaW1lU3RhbXAiOjE3MTg1ODMwNzcsImNvbnRlbnRJbmZvIjp7ImF1ZGlvVmlkZW9UeXBlIjoiT3JpZ2luYWwifSwidXJsQWNjZXNzSW5mbyI6eyJkb21haW4iOiIxMzE4MTY3MjIzLnZvZC1xY2xvdWQuY29tIiwic2NoZW1lIjoiSFRUUFMifX0.6376t_3II_BMeRAfeAZ8CFZNN6UimAPzj3Fe5pELTWw',  
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1318167223_1/v_cube.license',
        });
        ulog.UserLog.path = router.currentRoute.value.fullPath;
        console.log("当前页面路径=="+ulog.UserLog.path) 
        postUserLog(ulog.UserLog).then(() => {
         
        });
        /**登陆验证 */
        getCheckBinding().then((res1) => {
                console.log(res1.data.code);
                const binding = res1.data.code;
                if (binding == 60002) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定进度未完成】：我们会在1～3个工作日内完成";
                    goToUserInfo.value = true;
                } else if (binding == 60000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定异常】：早知心，目前仅向我院体检机构服务的客户提供服务。您可以向我院体检机构获取【邀请码】";
                    goToUserInfo.value = true;
                } else if (binding == 40000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【登陆异常】：请您在微信端打开";
                
                } else {
                     getUserInfo().then((res3) => {
                        state.userInfo = res3.data.data;
                        console.log(res3.data.data);
                    })
                }
            })

   })
   return {
     //fid,
     player,
     themeVars,
     kpian,
     kpianawait,
     themeVars2,
     goToUserInfo,
     bingingNotice,
     showOverlay,
     ...toRefs(state),
   }
 }
}
</script>
<style scoped>
@import url("//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css");
#app {
 font-family: Avenir, Helvetica, Arial, sans-serif;
 -webkit-font-smoothing: antialiased;
 -moz-osx-font-smoothing: grayscale;
 text-align: center;
 color: #2c3e50;
}

.textIndentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 line-height:30px;
}
.textMain {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 line-height:30px;
}

.text2Indentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1px;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}

.match {
 text-align: left;
 text-indent: 1em;
 font-size: 14px;
}

.text3Indentation {
 text-align: left;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}
</style>
